module.exports = __webpack_public_path__ + "img/bg3s.219d16b7.png";